/**
 * Підписи полів заявки — дослівно з легасі (`SPEC-021` §4.1, `uk.json`).
 * Одне джерело для ресурсу, картки, «Рейсів», канбану й вкладок CRM.
 */
export const APPLICATION_FIELD_LABELS = {
    id: 'Ід',
    title: 'Назва',
    status: 'Статус',
    client: 'Клієнт',
    isConfirmedClient: 'Підтверджено клієнтом',
    loadingCountries: 'Країни завантаження',
    loadingAddresses: 'Адреси завантаження',
    unloadingCountries: 'Країни розвантаження',
    unloadingAddresses: 'Адреси розвантаження',
    cargo: 'Вантаж (Кількість, розміри, вага)',
    typesCars: 'Тип автомобіля',
    dateLoading: 'Дата завантаження',
    description: 'Додаткова інформація',
    planneDateUnloading: 'Дата вивантаження (ПЛАН)',
    forwarder1: 'Експедитор клієнта',
    costClient: 'Вартість клієнту',
    costClientCurrency: 'Валюта',
    placeCountryDeparture: 'Місце митного оформлення в місці відправлення',
    personResponsibleLoading: 'Відповідальна особа за завантаження',
    placeDestination: 'Місце митного оформлення в місці призначення',
    personResponsibleUnloading: 'Відповідальна особа за вивантаження',
    costCargoInvoice: 'Вартість вантажу за інвойсом',
    dateUnloading: 'Дата вивантаження (ФАКТ)',
    files: 'Файли',
    amountProfitUAH: 'Прибуток',
    manager: 'Менеджер клієнт',
    responsible: 'Менеджер логіст',
    dateAdditionResponsible: 'Дата додавання відповідального (логіста)',
    forwarder2: 'Експедитор перевізника',
    carrier: 'Перевізник',
    numberVehicle: 'Державний номер ТЗ',
    driver: 'Водій та контакти',
    borderCrossing: 'Прикордонний перехід',
    costToBorder: 'Вартість до кордону',
    costToBorderCurrency: 'Валюта',
    typeNumberVehicles: 'Тип та кількість транспортних засобів',
    method: 'Спосіб завантаження/розвантаження',
    costCarrier: 'Вартість перевізника',
    costCarrierCurrency: 'Валюта',
    paymentTerm: 'Термін оплати',
    dateDeliveryCustoms: 'Дата доставки на митницю',
    consignor: 'Вантажовідправник',
    consignee: 'Вантажоодержувач',
    quantityWeightCargo: 'Додаткові умови',
    clientContract: 'Договір з клієнтом',
    carrierContract: 'Договір з перевізником',
    request: 'Запит',
    tender: 'Тендер',
    lossReason: 'Причина програшу',
    lossComment: 'Коментар програшу',
    isProblem: 'Проблемне замовлення',
    problem: 'Опис проблеми',
    isSolvedProblem: 'Проблема вирішена',
    solvedProblem: 'Опис вирішення проблеми',
    statusClient: 'Статус для клієнта',
    dateUpdateStatusClient: 'Дата оновлення статусу для клієнта',
    createdAt: 'Створено',
    createdBy: 'Хто створив',
    updatedAt: 'Дата зміни',
    updatedBy: 'Хто змінив',
} as const

/**
 * Підписи полів у переліку «чого бракує». Три поля валюти в картці стоять поруч
 * зі своєю сумою й підписані просто «Валюта», а в переліку без сусідства
 * незрозуміло, яка з трьох.
 */
export const APPLICATION_REQUIREMENT_LABELS: Record<string, string> = {
    ...APPLICATION_FIELD_LABELS,
    costClientCurrency: 'Валюта вартості клієнту',
    costToBorderCurrency: 'Валюта вартості до кордону',
    costCarrierCurrency: 'Валюта вартості перевізника',
}

/** Тексти кнопок, модалок і повідомлень заявки (`SPEC-021` §8.6, §8.8, `uk.json`). */
export const APPLICATION_TEXTS = {
    successTitle: 'Успіх',
    errorTitle: 'Помилка',
    contactAdmin: 'Зверніться до адміністратора системи.',
    save: 'Зберегти',
    close: 'Закрити',
    actionsMenu: 'Інші дії',
    updateStatus: 'Оновити статус',
    updateStatusTitle: 'Статус для клієнта',
    updateStatusSuccess: 'Статус успішно оновлено.',
    copy: 'Копіювати',
    chat: 'Чат',
    reportProblem: 'Проблемне замовлення',
    reportProblemTitle: 'Опис проблеми',
    resolveProblem: 'Проблема вирішена',
    resolveProblemTitle: 'Як вирішено?',
    resolveProblemSuccess: 'Проблему вирішено.',
    unload: 'Вивантажився',
    unloadTitle: 'Оберіть дату розвантаження',
    saved: 'Успішно збережено.',
    lose: 'Програти',
    loseSuccess: 'Заявку успішно програно.',
    required: 'Заповніть поле.',
    /** Заголовок вікна «чого бракує» біля кроку смуги — з назвою кроку. */
    requirementsTitle: (title: string) => `Щоб перейти в статус «${title}», потрібно:`,
    requirementsSatisfied: (title: string) => `Для переведення в статус «${title}» всі умови виконано.`,
} as const
